import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Alert,
  FormControlLabel,
  Checkbox,
  Grid,
  Button,
  Modal,
} from '@mui/material';
import { useAppData } from "../../redux/appDataProvider";
import axios from 'axios';
import ApiClient from "../../utilities/apiClient";
import AppConfig from "../../AppConfig";
import { useSelector } from 'react-redux';
import MyLodder from "../../components/lodder";

const PdfPreview = ({ open, onClose, pdfUrl, loading, responseData,callApi }) => {
  const sanitizedUrl = pdfUrl ? `${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0` : '';
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [eSignRes, seteSignRes] = useState({});
  const [pdfError, setPdfError] = useState(null);
  const { userInfo, setUserInfo } = useAppData();
   const [showlodder, setShowLodder] = useState(false);

    const apiToken = useSelector(state => state.auth.apiToken);

  console.log(userInfo)
  console.log('resdataaa',responseData)
  console.log(pdfError)

  useEffect(() => {
    if(callApi){
       setShowLodder(true);
    (async () => {
        try {
          console.log("INSIDE TRY", AppConfig.api.A_esign.e_sign)
            setPdfError(null);

          const apiClient = new ApiClient(apiToken);
          // const response = await apiClient.fetchData(
          //   AppConfig.api.A_esign.e_sign,
          //   "POST",
          //   responseData
          // );
            const response = await axios.post(
              AppConfig.api.A_esign.e_sign,
              responseData, {
              headers: {
                "Content-Type": "application/json",
              },
            }            
            );

          console.log("RES", response?.data?.data)


            if (response?.data?.data.success) {
              seteSignRes(response?.data?.data);
                setShowLodder(false);
            } else if (response.status === 500) {
                const errorMessage =
                    response.statusText ||
                    (response.data?.details && response.data.details["Error Description"]);
                console.error("Error 500:", errorMessage);
                setShowLodder(false);
                // setPdfError(true);
            } else {
                console.warn("Unexpected response status:", response.status);
                setShowLodder(false);
                // setPdfError(true);
            }
        } catch (error) {
            console.error("Error during API request:", error);
            // setPdfError(true);
            setShowLodder(false);
        }
    })();
  }
}, [responseData]);

console.log('URLLL',eSignRes?.url)


  return (
    <>
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '95vw',
          maxWidth: '950px',
          maxHeight: '80vh',
          bgcolor: ' #101820',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
        }}
      >
        <Typography sx={{ fontWeight: 'bold', fontSize: '20px', mb: 3 }}>
          Account closure Form preview
        </Typography>

        {pdfError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            Error in eSign step. Please try again later.
          </Alert>
        )}

          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '300px',
              }}
            >
              <CircularProgress />
            </Box>
          ) : pdfUrl ? (
            <Paper
              elevation={3}
              sx={{
                overflow: 'hidden',
                borderRadius: 2,
                height: '300px', // Add this height to properly size the PDF container
              }}
            >
              <Box
                component="object"
                data={sanitizedUrl}
                type="application/pdf"
                width="100%"
                height="100%" // Make the PDF occupy full height of its container
                sx={{ border: 'none' }}
              >
                <Typography sx={{ p: 2 }}>
                  PDF preview is not supported on your device.{" "}
                  <a href={sanitizedUrl} download={`${userInfo.CLIENT_ID}_account_closure.pdf`}>
                    Click here to download
                  </a>
                </Typography>
              </Box>
            </Paper>
          ) : null}

        {pdfUrl && (
          <>
            <Grid sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAcknowledged}
                    onChange={(e) => setIsAcknowledged(e.target.checked)}
                    sx={{ color: "#fff" }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                    By proceeding, I acknowledge that I have fully read, completely understood and agree to the Terms & Conditions, Disclaimers and Privacy Policy of TradeBoss.
                  </Typography>
                }
              />
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                disabled={!isAcknowledged}
                sx={{
                  fontWeight: 600,
                  backgroundColor: isAcknowledged ? '#F3D45E' : '#ccc',
                  color: isAcknowledged ? '#000' : '#666',
                }}
                onClick={() => {
                  if (eSignRes?.url) {
                    window.open(eSignRes?.url, "_self");
                  }
                }}
              >
                Proceed to Aadhaar eSign
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
     <MyLodder canShow={showlodder} />
    </>
  );
};

export default PdfPreview;
